module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn waves-effect waves-light",
    class: _vm.classes,
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.confirmDelete($event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de2c1a74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/ConfirmDelete.vue
// module id = 271
// module chunks = 0